export const colorsChartTheme5 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    cyan: {
        dark: {
            light: "rgba(217, 115, 26, 1)",
            dark: "rgba(242, 141, 53, 1)"
        },
        medium: {
            light: "rgba(231, 137, 54, 1)",
            dark: "rgba(255, 164, 84, 1)"
        },
        light: {
            light: "rgba(240, 180, 127, 1)",
            dark: "rgba(255, 205, 161, 1)"
        },
        darker: {
            light: "rgba(146, 77, 17, 1)",
            dark: "rgba(171, 100, 38, 1)"
        },
        lighter: {
            light: "rgba(240, 180, 127, 1)",
            dark: "rgba(255, 205, 161, 1)"
        },
        disabled: {
            light: "rgba(240, 180, 127, 1)",
            dark: "rgba(255, 205, 161, 1)"
        }
    },
    purple: {
        medium: {
            light: "rgba(6, 108, 199, 1)",
            dark: "rgba(29, 132, 224, 1)"
        },
        darker: {
            light: "rgba(3, 54, 99, 1)",
            dark: "rgba(16, 74, 125, 1)"
        },
        dark: {
            light: "rgba(4, 76, 139, 1)",
            dark: "rgba(22, 98, 166, 1)"
        },
        light: {
            light: "rgba(7, 130, 237, 1)",
            dark: "rgba(33, 152, 255, 1)"
        },
        lighter: {
            light: "rgba(116, 188, 251, 1)",
            dark: "rgba(143, 203, 255, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(119, 217, 89, 1)",
            dark: "rgba(151, 242, 124, 1)"
        },
        medium: {
            light: "rgba(61, 148, 34, 1)",
            dark: "rgba(85, 173, 57, 1)"
        },
        dark: {
            light: "rgba(61, 148, 34, 1)",
            dark: "rgba(85, 173, 57, 1)"
        },
        darker: {
            light: "rgba(61, 148, 34, 1)",
            dark: "rgba(85, 173, 57, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(152, 135, 171, 1)",
            dark: "rgba(218, 215, 222, 1)"
        },
        "lighter-weight": {
            light: "rgba(172, 159, 188, 1)",
            dark: "rgba(208, 203, 214, 1)"
        },
        light: {
            light: "rgba(131, 111, 155, 1)",
            dark: "rgba(185, 175, 196, 1)"
        },
        "light-weight": {
            light: "rgba(141, 123, 163, 1)",
            dark: "rgba(173, 160, 189, 1)"
        },
        medium: {
            light: "rgba(101, 84, 120, 1)",
            dark: "rgba(163, 148, 181, 1)"
        },
        dark: {
            light: "rgba(81, 67, 96, 1)",
            dark: "rgba(130, 116, 145, 1)"
        },
        darker: {
            light: "rgba(71, 59, 84, 1)",
            dark: "rgba(110, 98, 122, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(207, 66, 92, 1)",
            dark: "rgba(232, 97, 122, 1)"
        },
        light: {
            light: "rgba(224, 83, 109, 1)",
            dark: "rgba(224, 83, 109, 1)"
        },
        lighter: {
            light: "rgba(235, 113, 135, 1)",
            dark: "rgba(235, 113, 135, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
